import { getData } from "../helpers";
import { SupplierModal } from "../views/admin/purchases/suppliers/modals/store";

class ButtonSupplier extends HTMLButtonElement {
    connectedCallback() {
        this.test();
        this.load();
        this.events();
    }

    test() {
        // No borrar este método, pero sí su contenido
    }

    load() {
        //
    }

    events() {
        this.addEventListener("click", (e) => {
            SupplierModal.create(
                getData(this, "data-bs-target"),
                getData(this, "title"),
                getData(this, "data-url")
            );
        });
    }
}

window.customElements.define("button-supplier", ButtonSupplier, {
    extends: "button",
});
